import { cardsData } from '@/mocks/home';

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          精选推荐
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12 max-w-xl mx-auto">
          每日更新编辑精选，从海量内容中为你挑出最值得一看的好片
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {cardsData.map((card) => (
            <div
              key={card.id}
              className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-200/60 transition-colors group cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-white text-xs rounded-md whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed flex-1 line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}